"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigitalSignatureModel = void 0;
var mobx_1 = require("mobx");
var crypto_pro_js_1 = require("crypto-pro-js");
var mobx_utils_1 = require("mobx-utils");
var common_1 = require("../common");
var DigitalSignatureModel = /** @class */ (function () {
    function DigitalSignatureModel(signatureSetting, getFileByte, uploadSignature, uploadSignatureFile) {
        this.pluginIsAvailable = false;
        this.certificates = [];
        this.isPluginVariant = true;
        this.isUploading = false;
        this.oidAlgorithm = '';
        this.errorMessages = [];
        this.acceptedFiles = ['.sig', '.sgn', '.sign', '.p7s'];
        this.signatureSetting = signatureSetting;
        this.getFileByte = getFileByte;
        this.uploadSignature = uploadSignature;
        this.uploadSignatureFile = uploadSignatureFile;
        if (signatureSetting.signatureBrowserPlugin) {
            this.checkPluginAvailable();
        }
    }
    Object.defineProperty(DigitalSignatureModel.prototype, "isMultipleVariant", {
        get: function () {
            return this.signatureSetting.signatureBrowserPlugin && this.signatureSetting.signatureUpload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DigitalSignatureModel.prototype, "isDisabledButton", {
        get: function () {
            var selectedSignature = this.isPluginVariant ? this.selectedCertificate : this.uploadedSignature;
            return !selectedSignature || this.isUploading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DigitalSignatureModel.prototype, "uploadedSignatureFileName", {
        get: function () {
            var _a;
            return (_a = this.uploadedSignature) === null || _a === void 0 ? void 0 : _a.name;
        },
        enumerable: false,
        configurable: true
    });
    DigitalSignatureModel.prototype.onChangeSignatureVariant = function (event, isPluginVariant) {
        if (isPluginVariant !== null) {
            this.setIsPluginVariant(isPluginVariant);
            this.dropError();
        }
    };
    DigitalSignatureModel.prototype.setIsPluginVariant = function (isPluginVariant) {
        this.isPluginVariant = isPluginVariant;
    };
    DigitalSignatureModel.prototype.checkPluginAvailable = function () {
        var _this = this;
        crypto_pro_js_1.getSystemInfo()
            .then(function () {
            _this.setPluginIsAvailable(true);
            _this.getCertificates();
        })
            .catch(function (error) {
            console.error(error);
        });
    };
    DigitalSignatureModel.prototype.getCertificates = function () {
        var _this = this;
        crypto_pro_js_1.getUserCertificates()
            .then(function (data) {
            _this.setCertificates(data);
        })
            .catch(function () {
            _this.setPluginIsAvailable(false);
        });
    };
    DigitalSignatureModel.prototype.onChangeSelectedCertificate = function (e, value) {
        this.selectedCertificate = value;
    };
    DigitalSignatureModel.prototype.onChangeSignatureFile = function (_a) {
        var file = _a[0];
        if (!file) {
            return;
        }
        this.uploadedSignature = file;
    };
    DigitalSignatureModel.prototype.onDeleteSignatureFile = function () {
        this.uploadedSignature = undefined;
    };
    DigitalSignatureModel.prototype.setCertificates = function (certificates) {
        this.certificates = certificates;
        this.selectedCertificate = certificates[0];
    };
    DigitalSignatureModel.prototype.setPluginIsAvailable = function (isAvailable) {
        this.pluginIsAvailable = isAvailable;
    };
    DigitalSignatureModel.prototype.onSign = function (onSuccess) {
        var _this = this;
        var uploadFunc = this.isPluginVariant ? this.pluginUpload : this.fileUpload;
        uploadFunc()
            .then(function (signatureStatus) {
            _this.dropIsUploading();
            onSuccess(signatureStatus);
        })
            .catch(function (error) {
            var errorResponse = error.response;
            _this.setError(errorResponse ? errorResponse.data : error.message);
            _this.dropIsUploading();
        });
    };
    DigitalSignatureModel.prototype.pluginUpload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fileByte, hashSum, signature;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isUploading = true;
                        if (this.errorMessages) {
                            this.dropError();
                        }
                        if (!this.selectedCertificate) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.getAlgorithm()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getFileByte()];
                    case 2:
                        fileByte = _a.sent();
                        return [4 /*yield*/, crypto_pro_js_1.createHash(fileByte)];
                    case 3:
                        hashSum = _a.sent();
                        return [4 /*yield*/, crypto_pro_js_1.createDetachedSignature(this.selectedCertificate.thumbprint, hashSum)];
                    case 4:
                        signature = _a.sent();
                        return [4 /*yield*/, this.uploadSignature(signature)];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6: return [2 /*return*/, common_1.SignatureStatus.WITHOUT];
                }
            });
        });
    };
    DigitalSignatureModel.prototype.fileUpload = function () {
        var data = new FormData();
        if (this.uploadedSignature) {
            data.append('sign', this.uploadedSignature);
        }
        return this.uploadSignatureFile(data);
    };
    DigitalSignatureModel.prototype.getAlgorithm = function () {
        var _this = this;
        return this.selectedCertificate.getAlgorithm().then(function (data) {
            _this.setOidAlgorithm(data.oid);
        });
    };
    DigitalSignatureModel.prototype.setOidAlgorithm = function (oidAlgorithm) {
        this.oidAlgorithm = oidAlgorithm;
    };
    DigitalSignatureModel.prototype.setError = function (errors) {
        if (Array.isArray(errors)) {
            if (errors.length === 1) {
                this.errorMessages = [{ message: errors[0].validityCheckError }];
                return;
            }
            this.errorMessages = errors
                .filter(function (error) { return error.status === common_1.SignatureStatus.INVALID; })
                .map(function (error) { return ({
                title: error.subject.name,
                message: error.validityCheckError,
            }); });
            return;
        }
        this.errorMessages = [{ message: errors }];
    };
    DigitalSignatureModel.prototype.dropError = function () {
        this.errorMessages = [];
    };
    DigitalSignatureModel.prototype.dropIsUploading = function () {
        this.isUploading = false;
    };
    __decorate([
        mobx_1.observable
    ], DigitalSignatureModel.prototype, "pluginIsAvailable", void 0);
    __decorate([
        mobx_1.observable
    ], DigitalSignatureModel.prototype, "certificates", void 0);
    __decorate([
        mobx_1.observable
    ], DigitalSignatureModel.prototype, "selectedCertificate", void 0);
    __decorate([
        mobx_1.observable
    ], DigitalSignatureModel.prototype, "uploadedSignature", void 0);
    __decorate([
        mobx_1.observable
    ], DigitalSignatureModel.prototype, "isPluginVariant", void 0);
    __decorate([
        mobx_1.observable
    ], DigitalSignatureModel.prototype, "isUploading", void 0);
    __decorate([
        mobx_1.observable
    ], DigitalSignatureModel.prototype, "oidAlgorithm", void 0);
    __decorate([
        mobx_1.observable
    ], DigitalSignatureModel.prototype, "errorMessages", void 0);
    __decorate([
        mobx_1.observable
    ], DigitalSignatureModel.prototype, "signatureSetting", void 0);
    __decorate([
        mobx_1.observable
    ], DigitalSignatureModel.prototype, "getFileByte", void 0);
    __decorate([
        mobx_1.observable
    ], DigitalSignatureModel.prototype, "uploadSignature", void 0);
    __decorate([
        mobx_1.observable
    ], DigitalSignatureModel.prototype, "uploadSignatureFile", void 0);
    __decorate([
        mobx_1.computed
    ], DigitalSignatureModel.prototype, "isMultipleVariant", null);
    __decorate([
        mobx_1.computed
    ], DigitalSignatureModel.prototype, "isDisabledButton", null);
    __decorate([
        mobx_1.computed
    ], DigitalSignatureModel.prototype, "uploadedSignatureFileName", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "onChangeSignatureVariant", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "setIsPluginVariant", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "checkPluginAvailable", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "getCertificates", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "onChangeSelectedCertificate", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "onChangeSignatureFile", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "onDeleteSignatureFile", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "setCertificates", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "setPluginIsAvailable", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "onSign", null);
    __decorate([
        mobx_utils_1.asyncAction,
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "pluginUpload", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "fileUpload", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "getAlgorithm", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "setOidAlgorithm", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "setError", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "dropError", null);
    __decorate([
        mobx_1.action.bound
    ], DigitalSignatureModel.prototype, "dropIsUploading", null);
    return DigitalSignatureModel;
}());
exports.DigitalSignatureModel = DigitalSignatureModel;
